import React from 'react'
import { Box, Skeleton, Tab, Table, TableBody, TableCell, TableRow } from '@mui/material'
import { faBook } from '@fortawesome/pro-solid-svg-icons'
import CardChart from '../Components/CardChart'
import TitleClass from '../../../../Analytics/InternalLink/AnalyticsCurriculum/Current/Elements/TitleClass'
import ItemUl from '../../../../Analytics/InternalLink/AnalyticsCurriculum/Current/Elements/ItemUl'
import { useSelector } from 'react-redux'

const VCE = ({ isLoadingCurriculum, data }) => {
  const curriculum = useSelector(
    (state) => state?.assessment?.curriculum.find((x) => x.shortName === 'VCE') || {}
  )
  return (
    <CardChart icon={faBook} title='Periodical report VCE' bgColor='#fff' isLoading={isLoadingCurriculum}>
      <Table>
        <TableBody>
          {isLoadingCurriculum ? (
            Array.from({ length: 5 }).map((_, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Box className='flex gap-2 items-center'>
                    <Skeleton variant='text' width={130} />
                    <Skeleton variant='text' width={40} />
                  </Box>
                </TableCell>
                <TableCell>
                  <Box className='flex gap-2 items-center justify-end'>
                    <Skeleton variant='text' width={80} />
                  </Box>
                </TableCell>
              </TableRow>
            ))
          ) : data?.length > 0 ? (
            data.map((student, index) => (
              <Box key={student.classId}>
                <Box
                  className='bg-primary text-primary-foreground grid sticky top-10 z-1'
                  sx={{ gridTemplateColumns: 'repeat(3, minmax(0, 1fr))' }}
                >
                  <TitleClass classData={student} showStudents={false} curriculum={curriculum} />
                </Box>
                <Table>
                  <TableBody>
                    {student.unitOfLearning.map((s) => (
                      <TableRow key={s.unitOfLearningId}>
                        <ItemUl ul={s} lcs={s.lcs} result={s.result} curriculum={curriculum} />
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={3}>
                <Box className='flex justify-center items-center py-4'>No data available</Box>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </CardChart>
  )
}

export default VCE
